import { CurrentAddress, PreviousAddress } from '../shared'
import { orderType } from '../../signup'
import { Package } from '@app/_models/package';
import { Employer } from '@app/_models/employer';
import { Education } from '@app/_models/education';
import { CreditCheck } from '@app/_models/creditCheck'
export class Order {
    candidate: Candidate;
    currentAddress: CurrentAddress;
    previousAddresses: string[];
    packageID: string;
    orderType: orderType;
    contactID: string;
    // haveSignedRelease: boolean;
    package?: Package;
    billToZip: string;
    billToState: string;
    addOnProducts: number[] = [];
    previousEmployers: Employer[] = [];
    education: Education[] = [];
    generateTestToken: boolean;
    testToken: string;
    creditCheck: CreditCheck[] = [];
}
export class Candidate {
    firstName: string;
    middleName: string;
    lastName: string;
    ssn: string;
    dob: Date;
    email: string;
    dlNumber?: string;
    dlState?: string;
}
